import { createSlice } from "@reduxjs/toolkit";
const permissionSlice = createSlice({
    name: "manage_permission",
    initialState: { permissionArr: [] },
    reducers: {
        storePermission: (state, action) => {
            state.permissionArr = action.payload;
        },
    },
});
export const { storePermission } = permissionSlice.actions;
export default permissionSlice.reducer;